
import { ILinks, ILinksService } from '../_types/interfaces';



const getLinksList = async (): Promise<Array<ILinks>> => {
    return new Promise<Array<ILinks>>(resolve => {
        const records = [{"Name":"Indiv","Address":"http://84.201.169.119:8015/","Icon":"i:cloud","NewTab":true}]
        setTimeout(() => resolve(records), 1000);
    });
};


export const fakeLinkService: ILinksService = {
    getLinksList,
};